import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import styled from 'styled-components';
import { defaultMuiTheme } from '../../../../styles/MaterialTheme';
import Magnifier from '../../../Magnifier';
import Paginator from '../../../Paginator';
import PDFDocument from './PDFDocument';
import PDFDownloadButton from './PDFDownloadButton';
const DocumentWrapper = styled.div `
    max-height: 100%;
    max-width: 100%;
    overflow: auto;

    ${defaultMuiTheme.breakpoints.up('sm')} {
        > div {
            display: flex;
            justify-content: center;
        }
    }
`;
const PDFModalActionsContainer = styled.div `
    display: flex;
    justify-content: space-between;
    padding: 0.375rem 1rem;
`;
const StyledMagnifierContainer = styled.div `
    button:first-of-type {
        margin-right: 0.5rem;
    }
`;
const PDFModal = ({ open, onClose, url, DocumentComponent, PageComponent, initialPage, totalPages }) => {
    const [scale, setScale] = useState(1);
    const [page, setPage] = useState(initialPage);
    useEffect(() => setPage(initialPage), [initialPage]);
    const zoomOut = () => {
        setScale((prev) => (prev > 1 ? prev - 1 : prev));
    };
    const zoomIn = () => {
        setScale((prev) => prev + 1);
    };
    return (React.createElement(Dialog, { "aria-label": "PDF viewer", fullWidth: true, maxWidth: "xl", open: open, onClose: () => onClose(page) },
        React.createElement(PDFModalActionsContainer, null,
            React.createElement(StyledMagnifierContainer, null,
                React.createElement(Magnifier, { zoomOut: zoomOut, zoomIn: zoomIn })),
            React.createElement(PDFDownloadButton, { href: url }),
            React.createElement(IconButton, { color: "primary", "aria-label": "close", onClick: () => onClose(page) },
                React.createElement(CloseIcon, null))),
        React.createElement(DocumentWrapper, null,
            React.createElement(DialogContent, { dividers: true },
                React.createElement(PDFDocument, { DocumentComponent: DocumentComponent, PageComponent: PageComponent, url: url, page: page, setPage: setPage, totalPages: totalPages, scale: scale }))),
        React.createElement(Paginator, { currentPage: page, totalPages: totalPages, onPreviousClick: () => setPage((prevPage) => prevPage - 1), onNextClick: () => setPage((prevPage) => prevPage + 1) })));
};
export default PDFModal;
//# sourceMappingURL=PDFModal.js.map